import React from 'react';
import Docs from '@/pages/Docs';

const OSHelp: React.FC = () => {
  return (
    <div className="h-full w-full overflow-hidden bg-background text-foreground">
      <Docs embedded />
    </div>
  );
};

export default OSHelp;
